module.exports = __webpack_public_path__ + "img/liaojiegengduo-erweima.849bae20.png";